const products = {
    products: {
        HaifaStimBooster: "Melhora a atividade metabólica em situações de stress",
        HaifaStimEnergy: "Melhora o equilíbrio de energia da planta",
        HaifaStimForce: "Economiza energia metabólica, apoiando a síntese de aminoácidos e proteínas",
        HaifaStimHumiK: "Apoia a atividade das raízes e a absorção de nutrientes",
        HaifaStimVigor: "Reforça e melhora a resistência da planta contra os estresses abióticos",
        HaifaStimVIM: "Melhora a fertilidade do solo e a eficiência da utilização de nutrientes",
        HaifaStimVital: "Melhora o desempenho da planta",
        HaifaStimWallUp:
            "Mistura ótima de micronutrientes selecionados para melhorar a resistência da planta contra estresses abióticos, melhora o crescimento e maximiza o rendimento",
        HaifaMicroCombi:
            "Uma mistura estável, solúvel em água e não produtora de pó de quelatos metálicos, Ferro, Manganês, Cobre, Zinco - todos presentes em forma quelada EDTA",
        PolyFeedFoliar1:
            "Poly-Feed™ Foliar alimenta as plantas, satisfaz as necessidades precisas durante as fases críticas de crescimento para os máximos rendimentos e a mais elevada qualidade.",
        PolyFeedFoliar2: "Fórmula específica para a colheita",
        PolyFeedStim: "combinação única de estimulantes naturais e fertilizantes NPK minerais",
        HaifaBonus: "Fertilizante rico em potássio para fórmulas de aplicação foliar eficientes baseadas no Multi-K™ potássio nitrato da Haifa.",
    },
};

export default products;
